/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import type { AxiosRequestConfig, AxiosResponse } from 'axios'
import { axiosInstance } from '../client'
import type {
	CampaignStatusReviewPathParams,
	CampaignStatusReviewRequest,
	CampaignStatusReviewResponse,
} from '../types/CampaignStatusReview'

/**
 * POST /campaigns/:campaign/submit-for-review
 * @see backend/nexus/modules/Campaign/Http/Controllers/CampaignStatusController.php CampaignStatusController::review
 */
export async function campaignStatusReview(
	campaign: CampaignStatusReviewPathParams['campaign'],
	data: CampaignStatusReviewRequest,
	config?: AxiosRequestConfig,
): Promise<AxiosResponse<CampaignStatusReviewResponse>> {
	return axiosInstance.post(`/campaigns/${campaign}/submit-for-review`, data, config)
}
